import React from 'react';
import { toast } from 'sonner';
import Toast from '../../../design-system/Toast';
import { ToastService } from './ToastService';

export function createToastService(): ToastService {
  return {
    open: options => {
      const id = toast.custom(
        (t: string | number) => (
          <Toast
            type={options.type}
            icon={options.icon}
            // dark
            action={options.action}
            onClose={() => {
              toast.dismiss(t);
              options.onClose?.();
            }}
            onCloseAll={() => {
              toast.dismiss();
              options.onCloseAll?.();
            }}
          >
            {options.message}
          </Toast>
        ),
        {
          position: 'bottom-right', // force for now
          duration:
            options.autoClose === false ? Infinity : (options.autoClose ?? 5000) // 5 seconds default
        }
      );
      return {
        dismiss: () => toast.dismiss(id)
      };
    }
  };
}
